module.exports = __webpack_public_path__ + "static/media/pan_sample_right.c82fc9f1.svg";